"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var _S3KeyFilter_1 = require("./_S3KeyFilter");
exports._NotificationConfigurationFilter = {
    type: "structure",
    required: [],
    members: {
        Key: {
            shape: _S3KeyFilter_1._S3KeyFilter,
            locationName: "S3Key"
        }
    }
};
//# sourceMappingURL=_NotificationConfigurationFilter.js.map